module.exports = __webpack_public_path__ + "img/Settings.1510b939.svg";